import { graphql, useStaticQuery } from "gatsby";
import { GiftableProductProps } from "@parksandresorts/core";

const query = graphql`
  query GiftableProductsQuery {
    allContentfulGiftableProductBlock {
      nodes {
        id
        contentful_id
        deliveryThemes {
          ...TextBlock
        }
      }
    }
  }
`;

export const useGiftableProductsDeliveryThemes = () => {
  const data = useStaticQuery(query);
  const products: Array<GiftableProductProps> = data?.allContentfulGiftableProductBlock?.nodes ?? [];
  return products.map((product) => product.deliveryThemes ?? []).flat();
};
